module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"messageCreationError":"Feil ved generering av melding","sendingErrors":"Feil ved sending av melding"},"en":{"messageCreationError":"Error generating message","sendingErrors":"Errpr sending message"}}')
  delete Component.options._Ctor
}
